<template>
    <div>
        <el-row>
            <el-form :model="filterData" ref="filterData" :inline="true">
                <el-col :xs="24" :sm="12" :xl="6" :lg="8" :md="12" class="case-inp">
                    <el-input v-model="filterData.case_title" :placeholder="$t('Case')" size="small" @keyup.enter.native="getCases()"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="6" :lg="8" :md="12" class="fach-select">
                    <el-select v-model="filterData.fachstellen_slug" :placeholder="$t('Fachstellen')" size="small" @change="getCases()" filterable clearable>
                        <el-option v-for="(item) in fachstellenList.data" :label="item.display_name" :key="item.slug" :value="item.slug"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="6" :lg="8" :md="12" class="case-select">
                    <el-select v-model="filterData.status" :placeholder="$t('Status')" size="small" @change="getCases()" filterable clearable>
                        <el-option v-for="(item, key) in caseStages" :label="$t(item)" :key="key" :value="key"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="6" :lg="8" :md="12" class="case-inp">
                    <el-date-picker style="width:100%" :picker-options="{disabledDate(date) { return date > new Date() || (filterData.end_date && date > new Date(filterData.end_date));}}" v-model="filterData.start_date" size="small" @change="getCases()" type="date" :placeholder="$t('Start date')" format="MM-dd-yyyy" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="6" :lg="8" :md="12" class="case-inp">
                    <el-date-picker style="width:100%" :picker-options="{disabledDate(date) {return date > new Date() || (filterData.start_date && date < new Date(filterData.start_date));}}" v-model="filterData.end_date" size="small" @change="getCases()" type="date" :placeholder="$t('End date')" format="MM-dd-yyyy" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-col>
            </el-form>
        </el-row>
        <el-row>
            <div class="rec-dev">
                <el-card class="box-card" v-for="(item) in cases.data" :key="item.id">
                    <div class="basic-detail">
                        <p><span class="title-text">{{ $t('Case Title') }}:</span>
                            <router-link :to="gotoDetail(item)">{{ item.case_title }}</router-link>
                        </p>
                        <p><span class="title-text">{{ $t('Patenkind') }}:</span> {{ item.patenkinder_name }}</p>
                    </div>
                    <div class="basic-detail">
                        <p><span class="title-text">{{ $t('Fachstellen') }}:</span> {{ item.fachstellen_name }}</p>
                        <p><span class="title-text">{{ $t('Fachstellen type') }}:</span> {{ item.fachstellen_type
                            }}</p>
                        <p><span class="title-text">{{ $t('Date') }}:</span> <span v-date-time-format="item.created_at"></span></p>
                    </div>
                    <div class="amount-detail">
                        <p><span class="title-text">{{ $t('Expected amount') }}:</span> {{ item.expected_amount | currency-format }}</p>
                        <p v-if="item.status_key == 'donated'"><span class="title-text">{{ $t('Confirmed amount')
                                }}:</span> {{ item.approved_amount | currency-format }}</p>
                    </div>
                    <div class="action-detail">
                        <div class="thumbs">
                            {{ item.case_up_votes }}<i class="icon-up-votes"></i>
                            {{ item.case_down_votes }}<i class="icon-down-votes"></i>
                        </div>
                        <el-tooltip class="item" effect="dark" :content="$t('Go for voting')" placement="left-end" :disabled="isTouchDevice()">
                            <el-button @click="voteNowPopup(item)" type="info" size="mini" circle plain :disabled="(item.status_key != 'stage_1')">
                                <i aria-hidden="true" class="el-icon-arrow-right"></i>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" :content="$t('Confirm')" placement="left-end" :disabled="isTouchDevice()">
                            <el-button @click="approveCasePopUp(item)" size="mini" type="success" plain circle :disabled="(item.status_key == 'donated' || item.status_key == 'rejected')">
                                <i aria-hidden="true" class="el-icon-check"></i>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" :content="$t('Reject')" placement="left-end" :disabled="isTouchDevice()">
                            <el-button @click="rejectCasePopUp(item)" size="mini" type="danger" circle plain :disabled="(item.status_key == 'donated' || item.status_key == 'rejected')">
                                <i aria-hidden="true" class="el-icon-close"></i>
                            </el-button>
                        </el-tooltip>
                        <p class="status-lbl">
                            <el-tag size="mini" :type="getStatusType(item.status_key)">
                                {{ $t(item.status_key) }}
                            </el-tag>
                        </p>
                    </div>
                </el-card>
            </div>
            <el-dialog :title="$t('Amount')" :visible.sync="ApproveDialog" :append-to-body="true" @open="appform.approved_amount = dummyRow.expected_amount">
                <el-form :model="appform" ref="appformData">
                    <el-form-item :label="$t('Confirmed amount')" prop="approved_amount" :rules="[{ required: true, message: $t('This field is required')}]">                        
                        <div class="el-input el-input-group el-input-group--prepend">
                            <div class="el-input-group__prepend">{{ $store.state.config.generalSettings.currency_code }}</div>
                            <input v-model="appform.approved_amount" type="text" autocomplete="off" class="el-input__inner" 
                            v-mask="{'alias': 'numeric', 'groupSeparator': '\'', 'autoGroup': true, 'digits': 2, 'digitsOptional': false, 'prefix': '', 'placeholder': '0'}">
                        </div>
                    </el-form-item>
                    <el-form-item :label="$t('Description')" prop="remark" :rules="[{ required: true, message: $t('This field is required')}]">
                        <el-input type="textarea" v-model="appform.remark"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" :loading="isLoading" @click="confirmCase('appformData',0)"> {{
                            $t('Approve') }}</el-button>
                        <el-button type="primary" :loading="isLoading" @click="confirmCase('appformData',1)">
                            {{ $t('Approve and send email') }} </el-button>
                        <el-button type="cancel" @click="ApproveDialog = false">{{$t('Cancel')}}</el-button>
                    </el-form-item>
                    <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
                </el-form>
            </el-dialog>
            <el-dialog :title="$t('Reject case')" :visible.sync="RejectDialog" :append-to-body="true">
                <el-form :model="form" ref="formData">
                    <el-form-item :label="$t('Description')" prop="remark" :rules="[{ required: true, message: $t('This field is required')}]">
                        <el-input type="textarea" v-model="form.remark"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" :loading="isLoading" @click="rejectCase('formData',0)"> {{
                            $t('Reject') }}</el-button>
                        <el-button type="primary" :loading="isLoading" @click="rejectCase('formData',1)">
                            {{ $t('Reject and send email') }} </el-button>
                        <el-button type="cancel" @click="RejectDialog = false">{{$t('Cancel')}}</el-button>
                    </el-form-item>
                    <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
                </el-form>
            </el-dialog>
            <el-dialog :title="$t('Voting note')" :visible.sync="votingNoteDialog" :append-to-body="true">
                <el-form :model="votingNoteForm" ref="votingNoteForm">
                    <el-form-item :label="$t('Description')" prop="org_description" :rules="[{ required: true, message: $t('This field is required')} ]">
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 40}"v-model="votingNoteForm.org_description"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" :loading="isLoading" @click="voteNow('votingNoteForm')">
                            {{ $t('Save') }} </el-button>
                        <el-button type="cancel" @click="votingNoteDialog = false">{{$t('Cancel')}}</el-button>
                    </el-form-item>
                    <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
                </el-form>
            </el-dialog>
        </el-row>
    </div>
</template>
<script>
    export default {
        props: {
            caseStages: Object
        },
        data() {
            return {
                filterData: {
                    page: 1,
                    pageLength: 10,
                    sortBy: "created_at",
                    order: "desc",
                    date_range: [],
                    organization_slug: (this.$store.state.config.user.organization_slug) ? this.$store.state.config.user.organization_slug : null,
                },
                fachstellenList: {},
                patenkinderList: {},
                cases: {},
                ApproveDialog: false,
                RejectDialog: false,
                votingNoteDialog: false,
                isLoading: false,
                form: {},
                appform: {
                    approved_amount: null
                },
                votingNoteForm: {},
                dummyRow: {}
            }
        },
        mounted() {
            this.getCases();
            this.getAllFachstellen();
        },
        methods: {
            isTouchDevice() {
                var a = navigator.userAgent || navigator.vendor || window.opera;
                if (
                    /android|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(ad|hone|od)|iris|kindle|lge |maemo|meego.+mobile|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|playbook|silk/i
                    .test(a) ||
                    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(di|rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
                    .test(a.substr(0, 4))) {
                    return true;
                } else {
                    return false;
                }
            },
            getStatusType(status_key) {
                var statusType = '';
                switch (status_key) {
                    case 'stage_1':
                        statusType = 'info';
                        break;
                    case 'stage_2':
                        statusType = 'warning'
                        break;
                    case 'stage_3':
                        statusType = '';
                        break;
                    case 'donated':
                        statusType = 'success';
                        break;
                    default:
                        statusType = 'danger';
                }
                return statusType;
            },
            gotoDetail(tab) {
                if (tab.status_key == "stage_1" || tab.status_key == "donated" || tab.status_key == "rejected") {
                    return {
                        name: 'CaseDetails',
                        params: {
                            id: tab.id
                        }
                    };
                } else if (tab.status_key == "stage_2") {
                    return {
                        name: 'CaseVoting',
                        params: {
                            id: tab.id
                        }
                    };
                } else {
                    return {
                        name: 'CaseReview',
                        params: {
                            id: tab.id
                        }
                    };
                }
            },
            getCases() {
                if ((this.filterData.start_date && !this.filterData.end_date) || (!this.filterData.start_date && this.filterData.end_date))
                    return false;
                request({
                        url: "patenkinder-cases",
                        method: "get",
                        params: this.filterData
                    }).then(response => {
                        this.cases = response.data;
                    })
                    .catch(error => {
                        this.$notify({
                            title: this.$t('Error'),
                            message: error.response.data.message,
                            type: "error",
                            offset: 50
                        });
                    });
            },
            getAllFachstellen() {
                request({
                        url: "get-all-fachstellen",
                        method: "get",
                        params: {
                            organization_slug: this.filterData.organization_slug,
                            club_slug: this.filterData.club_slug
                        }
                    }).then(response => {
                        this.fachstellenList = response.data;
                    })
                    .catch(error => {
                        this.$notify({
                            title: this.$t('Error'),
                            message: error.response.data.message,
                            type: "error",
                            offset: 50
                        });
                    });
            },
            voteNow(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.isLoading = true;
                        request({
                                url: "update-case-status",
                                method: "post",
                                data: {
                                    case_id: this.dummyRow.id,
                                    status: 'stage_2',
                                    org_description: this.votingNoteForm.org_description
                                }
                            })
                            .then(response => {
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: this.$t('Case added for club voting successfully!'),
                                    type: "success",
                                    offset: 50
                                });
                                this.votingNoteDialog = false;
                                this.dummyRow.status_key = 'stage_2';
                                this.dummyRow.status = this.caseStages.stage_2;
                                this.isLoading = false;
                                this.$refs[formName].resetFields();
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                                this.isLoading = false;
                            });
                    }
                });
            },
            confirmCase(formName, isEmail) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.isLoading = true;
                        request({
                                url: "update-case-status",
                                method: "post",
                                data: {
                                    case_id: this.dummyRow.id,
                                    status: 'donated',
                                    remark: this.appform.remark,
                                    approved_amount: this.appform.approved_amount,
                                    send: isEmail
                                }
                            })
                            .then(response => {
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: this.$t('Amount donated!'),
                                    type: "success",
                                    offset: 50
                                });
                                this.ApproveDialog = false;
                                this.dummyRow.status_key = 'donated';
                                this.dummyRow.status = this.caseStages.donated;
                                this.isLoading = false;
                                this.$refs[formName].resetFields();
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                                this.isLoading = false;
                            });
                    }
                });
            },
            rejectCase(formName, isEmail) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.isLoading = true;
                        request({
                                url: "update-case-status",
                                method: "post",
                                data: {
                                    case_id: this.dummyRow.id,
                                    status: 'rejected',
                                    remark: this.form.remark,
                                    send: isEmail
                                }
                            })
                            .then(response => {
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: this.$t('Case rejected!'),
                                    type: "success",
                                    offset: 50
                                });
                                this.RejectDialog = false;
                                this.dummyRow.status_key = 'rejected';
                                this.dummyRow.status = this.caseStages.rejected;
                                this.isLoading = false;
                                this.$refs[formName].resetFields();
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                                this.isLoading = false;
                            });
                    }
                });
            },
            voteNowPopup(item) {
                this.dummyRow = item;
                this.votingNoteDialog = true;
            },
            approveCasePopUp(item) {
                this.dummyRow = item;
                this.ApproveDialog = true;
            },
            rejectCasePopUp(item) {
                this.dummyRow = item;
                this.$confirm(
                    this.$t('Are you sure want to reject this case?'),
                    this.$t('Warning'), {
                        confirmButtonText: this.$t('Yes'),
                        cancelButtonText: this.$t('No'),
                        type: "warning",
                        cancelButtonClass: "el-button--cancel",
                        confirmButtonClass: "el-button--primary"
                    }
                ).then(() => {
                    this.RejectDialog = true;
                });
            }
        }
    }

</script>
<style lang="scss" scoped>
    .el-form {
        .el-col {
            margin-bottom: 15px;
        }

        .case-inp {
            padding-right: 15px;

            @media only screen and (max-width: 767px) {
                padding-right: 0px;
            }
        }

        .case-select {
            padding-right: 15px;

            @media only screen and (max-width: 767px) {
                padding-right: 0px;
            }
        }

        .fach-select {
            padding-right: 15px;

            @media only screen and (max-width: 1024px) {
                padding-right: 0px;
            }
        }
    }

    @media screen and (max-width: 992px) and (min-width: 769px) {
        .recent-case {
            .el-form {
                .el-col-sm-12 {
                    width: 100%;
                }
            }
        }

        .el-form {

            .case-inp,
            .case-select {
                padding: 0;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Layout/Cases/RecentCases.vue